import { render, staticRenderFns } from "./VouchersForm.vue?vue&type=template&id=828ffc5e"
import script from "./VouchersForm.vue?vue&type=script&lang=js"
export * from "./VouchersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports